module.exports = __webpack_public_path__ + "static/media/bracketsCurlyBlack.01a947cf.svg";